module.exports = __webpack_public_path__ + "img/earning-potential-sword.753769a3.png";